module.exports = __webpack_public_path__ + "media/images/FB-f-Logo__blue_50-9781dfde.png";